export default __webpack_public_path__ + "static/media/ProviderImage.80b0100e.svg";